import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { FormConsortiumKeys } from './types'

interface Schema {
    id: FormConsortiumKeys
}

const TYPE_CONSORCIO = '6'
const isRequired = (type: string) => type === TYPE_CONSORCIO

interface FormElements {
    input?: InputBuildProps & Schema
    layout: LayoutProps
}

export const FormConsortiumValue = (
    typeOfRestriction: string
): FormElements[] => [
    {
        input: {
            id: 'cotaConsorcio',
            label: 'Cota do consórcio',
            placeholder: 'Digite aqui',
            required: isRequired(typeOfRestriction)
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'numeroGrupo',
            label: 'Nº do grupo',
            placeholder: 'Digite aqui',
            required: isRequired(typeOfRestriction)
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    }
]
